import { css } from '@emotion/react';

import {
  halfSpacing,
  standardSpacing,
} from 'styles/global_defaults/scaffolding';

import { CategoryHeaderProps, NvCategoryHeader } from './nv-category-header';
import { CategoryItemProps, NvCategoryItem } from './nv-category-item';

export type CategoryProps = CategoryHeaderProps & {
  singleCategory?: boolean;
  show: boolean;
  items: CategoryItemProps[];
};

export const NvCategory = ({
  singleCategory,
  show,
  items,
  ...categoryHeaderProps
}: CategoryProps) => {
  const styles = css`
    padding-right: ${singleCategory ? '0' : `${halfSpacing}px`};
    width: 100%;
    min-width: 120px;
    max-width: 150px;
    display: flex;
    flex-direction: column;
    gap: ${standardSpacing}px;

    ul {
      padding-left: 0;
    }

    li {
      margin-bottom: ${standardSpacing}px;
      list-style-type: none;
    }

    li:last-of-type {
      margin-bottom: 0;
    }
  `;

  return (
    <div css={styles} role='menu' aria-label={categoryHeaderProps.title}>
      {!singleCategory && <NvCategoryHeader {...categoryHeaderProps} />}

      <ul>
        {items.map((item) => (
          <li key={item.label}>
            <NvCategoryItem singleCategory={singleCategory} {...item} />
          </li>
        ))}
      </ul>
    </div>
  );
};
